import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

export default function Footer({ marginTop = '200px' }) {
  const currentYear = new Date().getFullYear();

  return (
    <Box sx={{
      backgroundColor: '#1a1a1a',
      color: 'white',
      paddingTop: 6,
      paddingBottom: 4,
      position: 'relative',
      zIndex: 1,
      marginTop: marginTop,
    }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: 3 }}>
              <img 
                src="/WhiteLogo.png" 
                alt="bookloop Logo" 
                style={{ height: '40px', marginBottom: '16px' }}
              />
              <Typography variant="body2" sx={{ color: '#cccccc', mb: 2 }}>
                The easiest way to find and sell used textbooks on campus. 
                Connect with fellow students and save money on your academic journey.
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <IconButton size="small" sx={{ color: '#ffffff', '&:hover': { backgroundColor: '#6B89FF', color: '#ffffff' } }}>
                  <FacebookIcon />
                </IconButton>
                <IconButton size="small" sx={{ color: '#ffffff', '&:hover': { backgroundColor: '#6B89FF', color: '#ffffff' } }}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="24" height="24" fill="currentColor" style={{ display: 'block' }}>
                    <path d="M93.5 20H110L72.5 62.6L117 120H81.1L53.2 85.1L21.5 120H5.1L45.2 74.2L2 20.1H39.6L64.1 52.1L93.5 20ZM87.2 109.1H97.1L33.2 29.5H22.4L87.2 109.1Z" />
                  </svg>
                </IconButton>
                <IconButton size="small" sx={{ color: '#ffffff', '&:hover': { backgroundColor: '#6B89FF', color: '#ffffff' } }}>
                  <InstagramIcon />
                </IconButton>
                <IconButton size="small" sx={{ color: '#ffffff', '&:hover': { backgroundColor: '#6B89FF', color: '#ffffff' } }}>
                  <LinkedInIcon />
                </IconButton>
              </Box>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} md={2}>
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold' }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="/" variant="body2" sx={{ color: '#ffffff', textDecoration: 'none', '&:hover': { color: '#6B89FF', textDecoration: 'underline' } }}>
                Home
              </Link>
              <Link href="/listings" variant="body2" sx={{ color: '#ffffff', textDecoration: 'none', '&:hover': { color: '#6B89FF', textDecoration: 'underline' } }}>
                Find Textbooks
              </Link>
              <Link href="/my-listings" variant="body2" sx={{ color: '#ffffff', textDecoration: 'none', '&:hover': { color: '#6B89FF', textDecoration: 'underline' } }}>
                Sell Textbooks
              </Link>
              <Link href="/how-it-works" variant="body2" sx={{ color: '#ffffff', textDecoration: 'none', '&:hover': { color: '#6B89FF', textDecoration: 'underline' } }}>
                How It Works
              </Link>
              <Link href="/contact" variant="body2" sx={{ color: '#ffffff', textDecoration: 'none', '&:hover': { color: '#6B89FF', textDecoration: 'underline' } }}>
                Contact
              </Link>
            </Box>
          </Grid>

          {/* Support */}
          <Grid item xs={12} md={2}>
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold' }}>
              Support
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="/contact" variant="body2" sx={{ color: '#ffffff', textDecoration: 'none', '&:hover': { color: '#6B89FF', textDecoration: 'underline' } }}>
                Help Center
              </Link>
              <Link href="/contact" variant="body2" sx={{ color: '#ffffff', textDecoration: 'none', '&:hover': { color: '#6B89FF', textDecoration: 'underline' } }}>
                Contact Support
              </Link>
              <Link href="#" variant="body2" sx={{ color: '#ffffff', textDecoration: 'none', '&:hover': { color: '#6B89FF', textDecoration: 'underline' } }}>
                Terms of Service
              </Link>
              <Link href="#" variant="body2" sx={{ color: '#ffffff', textDecoration: 'none', '&:hover': { color: '#6B89FF', textDecoration: 'underline' } }}>
                Privacy Policy
              </Link>
              <Link href="#" variant="body2" sx={{ color: '#ffffff', textDecoration: 'none', '&:hover': { color: '#6B89FF', textDecoration: 'underline' } }}>
                Cookie Policy
              </Link>
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold' }}>
              Contact Us
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailIcon sx={{ fontSize: 20, color: '#6B89FF' }} />
                <Typography variant="body2" sx={{ color: '#cccccc' }}>
                  support@bookloop.com
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PhoneIcon sx={{ fontSize: 20, color: '#6B89FF' }} />
                <Typography variant="body2" sx={{ color: '#cccccc' }}>
                  +1 (555) 123-4567
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Bottom Section */}
        <Box sx={{ 
          borderTop: '1px solid #333', 
          mt: 4, 
          pt: 3, 
          display: 'flex', 
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2
        }}>
          <Typography variant="body2" sx={{ color: '#cccccc' }}>
            © {currentYear} bookloop. All rights reserved.
          </Typography>
          <Typography variant="body2" sx={{ color: '#cccccc' }}>
            Made with ❤️ for students
          </Typography>
        </Box>
      </Container>
    </Box>
  );
} 